import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
} from "reactstrap";
import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

export default class RejectRequest extends Component {
  constructor(props) {

    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation:null,
      startDate:moment().endOf("day"),
      endDate:moment().endOf("day"),
      pageText:'Your past orders',
      printSdkType:''
    };
  }

  componentWillMount(){
    this.checkLoginMode();
  }
  componentDidMount() {
    // document.getElementsByTagName("input")[0].setAttribute("readonly", "readonly");
    // document.getElementsByTagName("input")[0].setAttribute("readonly", "readonly");
    this.getOrders();
  }

  checkLoginMode = () => {
   
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if(loginMode === 'merchant'){
      this.setState({storeInformation:storeInformation,pageText:"Your Order Summary"});
    }else{
      this.setState({storeInformation:storeInformation});
    }
    
  };

  toggleModal = () => {
    this.getOrders()
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
    
  };
 
  handleStartDateChange =(date)=> {
    this.setState({
      startDate: date
    });
  }
  handleEndDateChange =(date)=> {
    if ((Date.parse(this.state.startDate.format("MM/DD/YYYY")) >= Date.parse(date.format("MM/DD/YYYY")))) {
      if((Date.parse(this.state.startDate.format("MM/DD/YYYY")) === Date.parse(date.format("MM/DD/YYYY"))))
      {
        this.setState({
          endDate: date
        });
        
        console.log("endDate 1"+date.format("MM/DD/YYYY"))
      }else{
        alert("End date should be greater than Start date");
      }
    }else{
      console.log("endDate 2"+date)
      this.setState({
        endDate: date
      });
    }
  }

  getOrders = async () => {
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    }

  
    // let date='';
    // if (this.state.startDate !== null) {
    //   date = this.state.startDate.format("YYYY-MM-DDT");
    //   date = date+"00:00:00+05:30";
    //   params.createdAt_Gte = date;
    // }
    // if (this.state.endDate !== null) {
    //   params.createdAt_Lte = this.state.endDate.format();
    // }

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getOrderRejectRequest",
      params
    );

    if (response.error === null) {

      let grandTotal = 0.0;
       for(let i=0; i < response.data.orderHistory.edges.length;i++){ 
        grandTotal = grandTotal + response.data.orderHistory.edges[i].node.cart.settlementPrice
        
        }
    
      this.setState({ orders: response.data.orderHistory.edges,grandTotal:grandTotal.toFixed(2) });

    }

    console.log("orderHistory",response);
  };

  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };

  getCSVData = () => {
    let date='';
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DDT");
      date = date+"00:00:00+00:00";
    }
    let csvData = [
      [
        this.state.pageText,
      ],
      [
        "Grand Total",
        "Start Date",
        "End Date",
        
      ],
      [
        this.state.grandTotal,
        date,
        this.state.endDate.format()
      ],
      [
        "",
      ],
      [
        "",
      ],
      [
        "Order Id",
        "Token",
        "Status",
        "Date/Time",
        "Amount",
        "Store"
      ]
    ];
    // eslint-disable-next-line
    this.state.orders.map(order => {
      csvData.push([
        order.node.orderId,
        order.node.storeToken,
        order.node.status,
        moment(order.node.createdAt).format("MMMM Do YYYY, h:mm a"),
        order.node.cart.settlementPrice,
        order.node.cart.pickupPoint.store.name
      ]);
    });
    // eslint-disable-next-line
    return csvData;
  };

  render() {

    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
        <Modal
          isOpen={this.state.orderModalVisible}
          toggle={this.toggleModal}
          size="lg"
        >
          <DetailedOrderCard
            editable={true}
            order={this.state.selectedOrder}
            toltalItemCount={null}
            goBack={this.toggleModal}
            refreshOrders={this.getOrders}
            pastOrder={true}
            storeInformation ={this.state.storeInformation}
          />
        </Modal>

        <Row noGutters>
          <Col>
            <Card>
              <CardHeader>
                <Container fluid>
                  <Row>
                  <Col
                    xs="12"
                    sm="12"
                    md="4"
                    lg="4"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <h5>{this.state.pageText}</h5>
                  </Col>
                  <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{'Grand Total= ' +this.state.grandTotal}</h5>
                  </Col>
                  </Row>
                {
                // <Row>
                //   <tr>
                //     <div
                //       style={{
                        
                //         justifyContent: "space-between"
                //       }}
                //     >
                //       <DatePicker
                //       selected={this.state.startDate}
                //       maxDate={moment().endOf("day")}
                //       dateFormat="DD/MM/YYYY"
                //       id ="input"
                //       readonly
                //       onChange={this.handleStartDateChange}
                //       />
                //       <div style = {{marginTop:15,marginBottom:15}}>
                //         <DatePicker
                //           selected={this.state.endDate}
                //           dateFormat="DD/MM/YYYY"
                //           id="input"
                //           disabledKeyboardNavigation ={true}
                //           maxDate={moment().endOf("day")}
                //           onChange={this.handleEndDateChange}
                //         />
                //       </div>
                //       <Button style={{marginLeft:20}} onClick = { this.getOrders}>Submit</Button>
                //         { this.state.storeInformation.store.printSdkType === SDK_CHROME ?
                //           <CSVLink
                //             className="btn btn-primary"
                //             style={{ marginLeft: 20 }}
                //             filename={"OrderSummary.csv"}
                //             data={this.getCSVData()}
                //           >
                //             Export to CSV
                //           </CSVLink>
                //           : null
                //         }
                //       </div>
                //       </tr>
                //   </Row>
                  }
                </Container>
              </CardHeader>
              <Table responsive>
                <tbody>
                  <tr>
                    <th>Order Id</th>
                    <th>Token</th>
                    <th>status</th>
                    <th>Date/Time</th>
                    <th>Amount</th>
                    <th>Store</th>
                  </tr>
                  {this.state.orders.map(order => {
                    return (
                      <tr
                        key={order.node.id}
                        onClick={() => {
                          this.setState({ selectedOrder: order });
                          this.toggleModal();
                        }}
                      >
                        <td>{order.node.orderId}</td>
                        <td>{order.node.storeToken}</td>
                        <td>{order.node.status}</td>
                        <td>
                          {moment(order.node.createdAt).format(
                            "MMMM Do YYYY, h:mm a"
                          )}
                        </td>
                        <td>{"₹" + order.node.cart.settlementPrice}</td>
                        <td>{order.node.cart.pickupPoint.store.name}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/RejectRequest/RejectRequest.js